import corpo from '@/assets/home-v2/corpo-bio.webp.asset.json';
import maos from '@/assets/home-v2/maos-bio.webp.asset.json';
import pes from '@/assets/home-v2/pes-bio.webp.asset.json';
import sab from '@/assets/home-v2/sab-bio.webp.asset.json';
import bal from '@/assets/home-v2/bal-pack.webp.asset.json';
import kg from '@/assets/home-v2/kg-bio.webp.asset.json';
import familia from '@/assets/home-v2/familia-1kg.webp.asset.json';
import rafaelLab from '@/assets/home-v2/rafael-lab.webp.asset.json';
import rafaelNatural from '@/assets/home-v2/rafael-natural.webp.asset.json';

export type Tone = 'corpo' | 'maos' | 'pes' | 'sab' | 'bal' | 'kg' | 'kits';

export const TONE_BG: Record<Tone, string> = {
  corpo: 'bg-v2-corpo',
  maos: 'bg-v2-maos',
  pes: 'bg-v2-pes',
  sab: 'bg-v2-sab',
  bal: 'bg-v2-bal',
  kg: 'bg-v2-corpo',
  kits: 'bg-v2-blue',
};

export interface MenuLink {
  title: string;
  desc?: string;
  href: string;
  tone?: Tone;
}

export interface MenuColumn {
  heading: string;
  links: MenuLink[];
  grid?: boolean;
  footerLink?: MenuLink;
}

export type FeatureCard =
  | { kind: 'quiz'; badge: string; title: string; text: string; cta: string; href: string }
  | { kind: 'photo'; badge: string; title: string; text?: string; image: string; href: string }
  | { kind: 'dark'; title: string; text: string; cta: string; href: string; avatar: string };

export interface MenuSection {
  id: string;
  label: string;
  href?: string;
  columns: MenuColumn[];
  bestSellers?: boolean;
  card: FeatureCard;
}

export const SHOP_NEEDS: MenuLink[] = [
  { title: 'Corpo', desc: 'Pele seca no dia a dia', href: '/loja/hidratantes', tone: 'corpo' },
  { title: 'Mãos', desc: 'De tanto lavar', href: '/loja/maos', tone: 'maos' },
  { title: 'Pés', desc: 'Rachados e calcanhar', href: '/loja/pes', tone: 'pes' },
  { title: 'Banho', desc: 'Corpo e rosto', href: '/loja/sabonete', tone: 'sab' },
  { title: 'Áreas muito secas', desc: 'Bálsamo', href: '/loja/balsamo', tone: 'bal' },
  { title: 'Tamanho família', desc: '1kg com pump', href: '/produto/hidratante-corporal-dermoconstrutor-1kg', tone: 'kg' },
  { title: 'Kits', desc: 'Rotinas prontas', href: '/loja/kits', tone: 'kits' },
];

export interface BestSeller { handle: string; name: string; short: string; image: string; tone: Tone }

export const BEST_SELLERS: BestSeller[] = [
  { handle: 'hidratante-corporal-dermoconstrutor-80g', name: 'Hidratante Corporal 80g', short: 'Corporal 80g', image: corpo.url, tone: 'corpo' },
  { handle: 'hidratante-para-as-maos-dermoconstrutor-80g', name: 'Hidratante para as Mãos 80g', short: 'Mãos 80g', image: maos.url, tone: 'maos' },
  { handle: 'hidratante-para-os-pes-dermoconstrutor-80g', name: 'Hidratante para os Pés 80g', short: 'Pés 80g', image: pes.url, tone: 'pes' },
  { handle: 'sabonete-liquido-extra-suave-150ml', name: 'Sabonete Líquido Extra Suave', short: 'Sabonete', image: sab.url, tone: 'sab' },
  { handle: 'balsamo-hidratante-corpo-e-rosto-30ml', name: 'Bálsamo Corpo e Rosto', short: 'Bálsamo', image: bal.url, tone: 'bal' },
  { handle: 'hidratante-corporal-dermoconstrutor-1kg', name: 'Hidratante Corporal 1kg', short: 'Tamanho família 1kg', image: kg.url, tone: 'kg' },
];

export const MENU_SECTIONS: MenuSection[] = [
  {
    id: 'loja',
    label: 'Loja',
    href: '/loja',
    bestSellers: true,
    columns: [
      {
        heading: 'Escolha pelo que sua pele precisa',
        grid: true,
        links: SHOP_NEEDS,
        footerLink: { title: 'Ver todos os produtos →', href: '/loja' },
      },
    ],
    card: {
      kind: 'quiz',
      badge: '3 perguntas · 1 minuto',
      title: 'Não sabe qual escolher?',
      text: 'Conte como sua pele está hoje e a gente indica o cuidado certo.',
      cta: 'Qual é o meu? →',
      href: '/quiz',
    },
  },
  {
    id: 'pele',
    label: 'Para sua pele',
    columns: [
      {
        heading: 'Como sua pele está hoje',
        links: [
          { title: 'Ressecada', desc: 'Repuxa, descama, coça', href: '/pele-ressecada-o-que-fazer' },
          { title: 'Sensível ou reativa', desc: 'Arde fácil, fica vermelha', href: '/pele-sensivel' },
          { title: 'Mãos e pés rachados', desc: 'Lavar muito, andar descalça', href: '/rotinas/maos-pes' },
          { title: 'Pele madura', desc: 'Mais fina e seca com a idade', href: '/para/geriatria' },
        ],
      },
      {
        heading: 'Momentos da vida',
        links: [
          { title: 'Em tratamento oncológico', desc: 'Cuidado gentil durante a quimio e a radio', href: '/para/oncologia' },
          { title: 'Gestação', desc: 'Barriga, seios e pele que muda', href: '/para/gestantes' },
          { title: 'Pós-procedimento', desc: 'Depois de laser e procedimentos', href: '/para/pos-procedimento' },
        ],
      },
    ],
    card: { kind: 'photo', badge: 'Quiz gratuito', title: 'Descubra a rotina da sua pele', text: '3 perguntas, indicação na hora.', image: familia.url, href: '/quiz' },
  },
  {
    id: 'ciencia',
    label: 'Ciência',
    columns: [
      {
        heading: 'Por dentro da fórmula',
        links: [
          { title: 'Como formulamos', desc: 'Menos ativos, mais precisão', href: '/ciencia-e-tecnologia' },
          { title: 'Segurança e testes', desc: 'HRIPT em laboratório independente', href: '/seguranca-testes' },
          { title: 'Bioativos', desc: 'Rosa-mosqueta, karité, aloe e mais', href: '/bioativos' },
        ],
      },
      {
        heading: 'Para ler com calma',
        links: [
          { title: 'Artigos', desc: 'Pele seca, sensível, rotina', href: '/blog' },
          { title: 'Barreira da pele', desc: 'O que é e como proteger', href: '/ciencia/barreira-cutanea' },
          { title: 'Glossário', desc: 'Os termos, sem complicação', href: '/glossario' },
        ],
      },
    ],
    card: { kind: 'photo', badge: 'Bioativos', title: 'Do que é feito cada creme', image: corpo.url, href: '/bioativos' },
  },
  {
    id: 'profissionais',
    label: 'Profissionais',
    columns: [
      {
        heading: 'Saúde',
        links: [
          { title: 'Médicos e prescritores', desc: 'Amostras e material técnico', href: '/profissionais-saude' },
          { title: 'Clínicas e hospitais', desc: 'Protocolos e compra institucional', href: '/clinicas' },
          { title: 'Protocolos de uso', desc: 'Oncologia, pós-operatório, geriatria', href: '/protocolos' },
        ],
      },
      {
        heading: 'Negócios',
        links: [
          { title: 'Seja revendedor', desc: 'Condições para revenda', href: '/revendedores' },
          { title: 'Programa de afiliados', desc: 'Indique e ganhe', href: '/afiliados' },
        ],
      },
    ],
    card: {
      kind: 'dark',
      title: 'Atende pacientes ou instituições?',
      text: 'Fale com nosso time B2B: protocolos, amostras e condições para volume.',
      cta: 'Solicitar proposta',
      href: '/parcerias',
      avatar: rafaelLab.url,
    },
  },
  {
    id: 'sobre',
    label: 'Sobre',
    columns: [
      {
        heading: 'A NAT HOF',
        links: [
          { title: 'Nossa história', desc: 'Por que a marca existe', href: '/sobre' },
          { title: 'Responsabilidade', desc: 'Embalagem e cadeia', href: '/sustentabilidade' },
        ],
      },
      {
        heading: 'Ajuda',
        links: [
          { title: 'Garantia de 7 dias', desc: 'Não gostou, devolvemos 100%', href: '/garantia' },
          { title: 'Perguntas frequentes', href: '/faq' },
          { title: 'Contato e WhatsApp', href: '/contato' },
        ],
      },
    ],
    card: {
      kind: 'photo',
      badge: 'Fundador',
      title: 'Conheça quem criou a NAT HOF',
      text: 'Rafael Cossiello, químico, mestre e doutor pela Unicamp',
      image: rafaelNatural.url,
      href: '/sobre',
    },
  },
];
